import React, { useEffect } from 'react'
import { useResizeDetector } from 'react-resize-detector/build/withPolyfill'
import { useDispatch } from '.'
import { HTMLDatasetUrls } from '../../../types/Configuration'
import { loadConfiguration } from '../../configuration'
import { fillConfigurationData } from '../../model/ConfigurationData'
import debuggerPause from '../../utils/debuggerPause'
import { resolveUrl } from '../../utils/urls'

const findIgnoreClosed = (el: HTMLElement | null | undefined): string[] => {
  if (!el) {
    return []
  }
  const target = el.closest<HTMLElement>('[data-cs-ignore-close]')
  const result = target?.dataset.csIgnoreClose ? target.dataset.csIgnoreClose.split(',') : []
  return result.concat(findIgnoreClosed(target?.parentElement))
}

export const useInit = (args: {
  wrapper: React.RefObject<HTMLDivElement>
  urls: HTMLDatasetUrls | null
  mode?: string
}): void => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (args.urls) {
      dispatch({
        type: 'Data/SetUrls',
        urls: args.urls
      })
    }
  }, [args.urls, dispatch])

  useEffect(() => {
    loadConfiguration(args.urls?.config).then((data) => {
      const urls = args.urls ?? {}
      const urlWithoutHash = resolveUrl(location.href.substring(0, location.href.length - location.hash.length))
      const initialMode =
        args.mode === 'expert'
          ? 'expert'
          : args.mode === 'inspiration'
          ? 'inspiration'
          : urlWithoutHash === urls.expertMode
          ? 'expert'
          : 'inspiration'

      dispatch({
        type: 'Data/Received',
        data: fillConfigurationData(data),
        urls: args.urls ?? {},
        initialMode
      })
    })
  }, [args.mode, args.urls, args.urls?.config, dispatch])

  const { width = 0, height = 0 } = useResizeDetector({ targetRef: args.wrapper })
  useEffect(() => {
    dispatch({
      type: 'Ui/Resize',
      screenSize: { width, height }
    })
  }, [width, height, dispatch])

  useEffect(() => {
    const clickListener = (e: MouseEvent) => {
      dispatch({
        type: 'Ui/BodyClick',
        ignore: findIgnoreClosed(e.target as HTMLElement)
      })
    }
    const keyUpListener = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        dispatch({
          type: 'Ui/Escape'
        })
      }
    }
    const keyDownListener = function (e: KeyboardEvent) {
      if (e.ctrlKey && e.key === 'd') {
        debuggerPause()
      }
    }
    document.body.addEventListener('click', clickListener, { passive: true })
    document.body.addEventListener('keyup', keyUpListener, { passive: true })
    window.addEventListener('keydown', keyDownListener, { passive: true })

    return () => {
      document.body.removeEventListener('click', clickListener)
      document.body.removeEventListener('keyup', keyUpListener)
      window.removeEventListener('keydown', keyDownListener)
    }
  }, [dispatch])
}
